const goodsManagement = {
    state: {
        queryKeyWordQuery: {}
    },
    getters: {
        getQueryKeyWordQuery: state => state.queryKeyWordQuery
    },
    mutations: {
        UPDATE_QUERY_KEY_WORD_QUERY: (state, data) => {
            state.queryKeyWordQuery = Object.assign({}, data)
        }
    },
    actions: {
        updateQueryKeyWordQuery({
            commit
        }, data) {
            commit('UPDATE_QUERY_KEY_WORD_QUERY', data)
        }
    }
}

export default goodsManagement